import { Box, MenuItem } from '@mui/material';
import { DialogTitle, CustomSelect, HorizontalForm, VerticalForm } from '../../../common';

const PermissionsSection = ({ selectedUser, onSelectChange, isMobile, roles }) => {
  if (isMobile) {
    return (
      <Box>
        <DialogTitle showSeparator={false}>Configuración</DialogTitle>
        <VerticalForm>
          <CustomSelect
            label="Rol"
            name="uuid_rol"
            value={selectedUser.uuid_rol || ''}
            onChange={onSelectChange}
            size="medium"
          >
            {roles.map((role) => (
              <MenuItem key={role.uuid} value={role.uuid}>
                {role.name}
              </MenuItem>
            ))}
          </CustomSelect>
        </VerticalForm>
      </Box>
    );
  }

  return (
    <Box>
      <DialogTitle showSeparator={false} sx={{ p: 0 }}>
        Configuración
      </DialogTitle>
      <HorizontalForm withBorder={false} sx={{ p: 1 }}>
        <Box sx={{ flex: 1, mr: isMobile ? 0 : 4 }}>
          <CustomSelect
            label="Rol"
            name="uuid_rol"
            value={selectedUser.uuid_rol || ''}
            onChange={onSelectChange}
            size="medium"
          >
            {roles.map((role) => (
              <MenuItem key={role.uuid} value={role.uuid}>
                {role.name}
              </MenuItem>
            ))}
          </CustomSelect>
        </Box>
        {!isMobile && <Box sx={{ flex: 1 }} />}
      </HorizontalForm>
    </Box>
  );
};

export default PermissionsSection;
